export function validarCnpjAlfanumerico(cnpj: any): boolean {
  const cnpjLimpo = String(cnpj)
    .replace(/[^a-zA-Z0-9]/g, '')
    .toUpperCase();

  if (cnpjLimpo.length !== 14 || new Set(cnpjLimpo).size === 1) {
    return false;
  }

  const isCnpjNumerico = /^\d+$/.test(cnpjLimpo);
  const tabelaConversao: { [key: string]: number } = {
    A: 10,
    B: 11,
    C: 12,
    D: 13,
    E: 14,
    F: 15,
    G: 16,
    H: 17,
    I: 18,
    J: 19,
    K: 20,
    L: 21,
    M: 22,
    N: 23,
    O: 24,
    P: 25,
    Q: 26,
    R: 27,
    S: 28,
    T: 29,
    U: 30,
    V: 31,
    W: 32,
    X: 33,
    Y: 34,
    Z: 35
  };

  const baseCalculo = [];
  for (let i = 0; i < 12; i++) {
    const char = cnpjLimpo[i];
    if (isCnpjNumerico) {
      baseCalculo.push(parseInt(char, 10));
    } else {
      baseCalculo.push(tabelaConversao[char] || parseInt(char, 10));
    }
  }

  const calcularDigito = (base: number[], pesos: number[]): number => {
    let soma = 0;
    for (let i = 0; i < base.length; i++) {
      soma += base[i] * pesos[i];
    }
    const resto = soma % 11;
    return resto < 2 ? 0 : 11 - resto;
  };

  const pesosDV1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  const dv1Calculado = calcularDigito(baseCalculo, pesosDV1);
  const dv1Fornecido = parseInt(cnpjLimpo.charAt(12), 10);

  if (dv1Calculado !== dv1Fornecido) {
    return false;
  }

  const baseCalculoDV2 = [...baseCalculo, dv1Calculado];
  const pesosDV2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  const dv2Calculado = calcularDigito(baseCalculoDV2, pesosDV2);
  const dv2Fornecido = parseInt(cnpjLimpo.charAt(13), 10);

  if (dv2Calculado !== dv2Fornecido) {
    return false;
  }

  return true;
}
